// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoryCardStyle } from "@conklin/App/Widgets/FeaturedCategories/FeaturedCategoryCard";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import IconHomepageStarCircle from "@conklin/XDL/Icons/IconHomepageStarCircle";
import { color, createLinkIconStyles, ellipsis, styledScrollbar, xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

featuredCategoryCardStyle.container = {
    css: css`
        padding-bottom: 18px;
        ${styledScrollbar(4, 0, false)}
    `,
};

featuredCategoryCardStyle.box = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        border: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            flex-wrap: nowrap;
            border: unset;
        }
    `,
};

featuredCategoryCardStyle.cardContainer = {
    css: css`
        width: 50%;
        gap: 12px;
        padding: 13px;
        padding-bottom: 17px;
        height: 204px;
        background-color: ${color("common.white")};
        &:first-child {
            border-right: 1px solid ${color("common.border")};
            border-bottom: 1px solid ${color("common.border")};
        }
        &:nth-child(2) {
            border-bottom: 1px solid ${color("common.border")};
        }
        &:nth-child(3) {
            border-right: 1px solid ${color("common.border")};
        }

        ${xScreen("lte", "md")} {
            &&&& {
                min-width: 215px;
                border-right: 1px solid ${color("common.border")};
                border-bottom: 1px solid ${color("common.border")};
                &:first-child {
                    border: 1px solid ${color("common.border")};
                    border-top: unset;
                }
            }
        }
    `,
};

featuredCategoryCardStyle.cardContainerLink = {
    css: css`
        width: 100%;
        height: 100%;
        &:hover {
            ${TypographyStyle} {
                color: ${color("common.ui10")};
            }
        }
    `,
    typographyProps: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            gap: 12px;
        `,
    },
};
featuredCategoryCardStyle.subtitle = {
    variant: "h6",
    forwardAs: "h3",
    color: "text.link",
    css: css`
        text-align: center;
        ${ellipsis(2)}
        margin-bottom: 0;
        width: 100%;

        &:hover {
            color: ${color("common.ui9")};
        }
    `,
};

featuredCategoryCardStyle.titleWrapper = {
    css: css`
        display: flex;
        width: 100%;
        position: relative;
        border: 1px solid ${color("common.border")};
        background: ${color("common.black")};
        border-radius: 4px 4px 0 0;
    `,
};

featuredCategoryCardStyle.starIcon = {
    src: IconHomepageStarCircle,
    size: 72,
    css: css`
        position: absolute;
        top: 0;
        right: 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

featuredCategoryCardStyle.titleLeftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        padding: 12px;
        align-items: flex-start;
        ${xScreen("lte", "md")} {
            padding: 12px 16px;
        }
    `,
};

featuredCategoryCardStyle.title = {
    variant: "h3",
    color: "common.white",
    css: css`
        margin: 0;
    `,
};

featuredCategoryCardStyle.link = {
    ...createLinkIconStyles(IconArrowRight, "small", "right", true, {
        icon: {
            iconProps: {
                css: css`
                    svg {
                        width: 11px;
                        height: 13px;
                    }
                `,
            },
        },
    }),
};
